import HTMLCode from "components/common/HTMLCode"
import { getFormContext } from "config/FormContext"
import { useContext, useEffect, useRef, useState } from "react"
import { InputCostumeErrorType, InputErrorType } from "types/form-types"
import { validateInput } from "utilities/input-utilities"
import InputErrors from "./input-common/InputErrors"
import InputLabel from "./input-common/InputLabel"

type CheckboxInputPropsType = {
    customErrors?: InputCostumeErrorType<boolean, HTMLInputElement>[]
    name?: string,
    id?: string
    autofill?: string
    label?: string | React.ReactNode
    required?: boolean
    autoFocus?: boolean
    value?: boolean,
    touched?: boolean,
    readonly?: boolean,
    disabled?: boolean,
    placeholder?: string,
    onChange?: (s: boolean | undefined, input: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (s: boolean | undefined, input: React.ChangeEvent<HTMLInputElement>) => void,
}

const CheckboxInput = (props: CheckboxInputPropsType) => {
    const input = useRef<HTMLInputElement>(null);
    const inputWrapper = useRef<HTMLDivElement>(null);
    let [touched, setTouched] = useState(props.touched ? true : false);
    let [errors, setErrors] = useState<InputErrorType[]>([]);
    const formContext = getFormContext(useContext);
   
    useEffect(() => {
        setTouched(formContext.submitted);
        validate(!formContext.submitted);
    }, [formContext.submitted])

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (typeof props.onChange == 'function') {
            props.onChange(e.currentTarget.checked, e);
        }

        if (touched) {
            validate();
        }
    };

    const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        setTouched(true);
        validate();
        if (typeof props.onBlur == 'function') {
            props.onBlur(e.currentTarget.checked, e);
        }
    }

    function validate(soft?: boolean) {
        setErrors(validateInput({
            value: props.value,
            input: input?.current || undefined,
            inputWrapper: inputWrapper?.current || undefined,
            customErrors: props.customErrors,
            soft: soft ? true : false
        }) || []);
    }

    return (
        <div className="app-input-wrapper checkbox" ref={inputWrapper}>
            <label className="inline-flex">
                <input
                    ref={input}
                    type="checkbox"
                    name={props.name}
                    required={props.required}
                    autoFocus={props.autoFocus}
                    checked={props.value}
                    onChange={onChange}
                    readOnly={props.readonly}
                    disabled={props.disabled}
                    placeholder="checkbox"
                    onBlur={onBlur}
                    className="accent-primary"
                />
                <HTMLCode />
                <InputLabel label={props.label} required={props.required} removeDoublePoints className='my-auto' />
            </label>
            <InputErrors errors={errors} />
        </div>
    );
};
export default CheckboxInput;
